<template>
<div class="lottery">
	<van-nav-bar :title="showtitle" left-text="" @click-left="back()" left-arrow />

	<!-- 历史记录 -->
	<div class="history" v-if="active" @click.self="active = false">
		<div class="history-content">
			<div class="history-header">
				<h3>{{$t('lishijl')}}</h3>
				<van-icon name="cross" class="close-icon" @click="active = false" />
			</div>
			<div class="history-body">
				<div class="history-columns">
					<p>{{$t('game.expect')}}</p>
					<p>{{$t('game.jieguo')}}</p>
				</div>
				<div class="history-table" ref="historyTable">
					<ul>
						<li class="history-record" v-for="(v,key) in lottery_list" :key="key">
							<div class="history-expect">{{v.expect}}</div>
							<div class="mak history-result">
								<div class="history-result-layout">
									<span class="history-result-sum">{{getResultSum(v.opencode)}}</span>
									<span class="history-result-label">{{getSizeText(v.opencode)}}</span>
									<span class="history-result-label">{{getDoubleText(v.opencode)}}</span>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>

	<!-- 顶部信息 -->
	<div class="top">
		<div class="qs">
			<div class="game-info">
				<div class="ico">
					<img :src="showimage" alt="" @error="retryImage">
				</div>
				<div class="info-text">
					<h1>{{lottery.next_expect}}</h1>
					<span class="countdown">
						<span class="countdown-label">{{$t('game.lefttime')}}:</span>
						<van-count-down :time="time" @finish="check()" />
					</span>
				</div>
			</div>
		</div>
		<div class="number">
			<div class="current-result">
				<div class="ball">
					<p>
						{{lottery.now_expect}}
						<br>
						{{$t('game.lunci')}}
					</p>
				</div>
			</div>
			<div class="result-display">
				<div class="res">
					<span class="result-item sum">{{sum}}</span>
					<span class="result-item size">{{size}}</span>
					<span class="result-item double">{{double}}</span>
				</div>
				<van-icon name="arrow-down" :class="{ up: active, down: !active }" @click="toggleHistory" />
			</div>
		</div>
	</div>

	<!-- 投注区域 -->
	<div class="lottery-content">
		<div class="betting-area">
			<div class="betting-options" id="toBottom">
				<div class="options-grid">
					<div class="option-item" 
						:class="{active: choose[v.type]}" 
						v-for="(v,key) in lottery_peilv_list" 
						:key="key" 
						@click="choosePlay(v.type, v.name)">
						<p>{{getBetName(v.name)}}</p>
						<span class="odds">({{v.proportion}})</span>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- 投注面板 -->
	<div class="betting-panel" v-if="shopping">
	  <div class="panel-content">
	    <div class="amount-and-total">
	      <div class="amount-input">
	        <p>{{$t('quantity')}}</p>
	        <input
	          type="number"
	          v-model.number="money"
	          min="0"
	          inputmode="decimal"
	          placeholder="0"
	          @focus="clearZeroAmount"
	          @blur="restoreZeroAmount">
	      </div>
	      <div class="total-info">
	        <p>
	          {{$t('total')}}
	          <span class="highlight">{{formData.length}}</span>
	        </p>
	      </div>
	    </div>
	  </div>
	</div>
	
	<!-- 游戏切换弹窗 -->
	<van-dialog
		v-model="showBetDetails"
		:title="$t('game.detail')"
		:confirm-button-text="$t('game.confirm')"
		:cancel-button-text="$t('cryptoWithdraw.cancel')"
		show-cancel-button
		@confirm="confirmBet">
		<div class="bet-detail-dialog">
			<div class="bet-detail-row"><span>{{$t('game.period')}}</span><strong>{{lottery.next_expect}}</strong></div>
			<div class="bet-detail-list">
				<div class="bet-detail-item" v-for="item in betDetailItems" :key="item.type">
					<span>{{item.label}}</span><em>{{item.odds}}</em><strong>{{money}}</strong>
				</div>
			</div>
			<div class="bet-detail-row"><span>{{$t('availablePoints')}}</span><strong>{{userInfo.money}}</strong></div>
		</div>
	</van-dialog>

	<van-popup v-model="showRight" position="right" :style="{ width: '65%', height: '100%' }">
		<div class="game-switch-popup">
			<div class="game-item" @click="toLottery(v.key, v.id)" v-for="(v,key) in game_type_list" :key="key">
				<p>{{v.name}}</p>
			</div>
		</div>
	</van-popup>
	
	<!-- 底部操作栏 -->
	<div class="footer">
		<div class="balance-info">
			<p>
				{{$t('availablePoints')}}
				<span class="balance">{{ userInfo.money }}</span>
			</p>
		</div>
		<button class="confirm-btn" @click="jiesuan">
			{{$t('voteAction')}}
		</button>
	</div>
</div>
</template>

<script>
var time;

export default {
  data() {
    return {
      showtitle: 'Lottery Games',
      showimage: '',
      title: '',
      choose: {
        "大": false, "小": false, "单": false, "双": false,
        "3": false, "4": false, "5": false, "6": false, "7": false, "8": false,
        "9": false, "10": false, "11": false, "12": false, "13": false, "14": false,
        "15": false, "16": false, "17": false, "18": false,
      },
      playgame: false,
      shopping: false,
      isLoading: false,
      showRight: false,
      game_type_list: [],
      play: {},
      lottery_peilv_list: {},
      lottery_list: {},
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: 0,
      size: "",
      double: "",
      time: 0,
      shopchoose: "Not selected",
      gameitem: "",
      formData: [],
      money: 0,
      showBetDetails: false,
      submittingBet: false,
      // 新增的控制变量
      isLoadingPeilv: false,
      isLoadingLotteryList: false,
      refreshTimer: null,
      isPageActive: false,
      retryCount: 0,
      MAX_RETRY: 3
    };
  },
  computed: {
    betTotal() {
      return Number(this.money || 0) * this.formData.length;
    },
    betDetailItems() {
      const oddsList = Array.isArray(this.lottery_peilv_list)
        ? this.lottery_peilv_list
        : Object.values(this.lottery_peilv_list || {});
      return this.formData.map(item => {
        const odds = oddsList.find(option => String(option.type) === String(item.type));
        return {
          type: item.type,
          label: this.getBetName(item.name),
          odds: odds ? `(${odds.proportion})` : ''
        };
      });
    }
  },
  methods: {
    retryImage(event) {
      const image = event && event.target;
      if (!image || image.dataset.cacheRetried === '1') return;
      image.dataset.cacheRetried = '1';
      try {
        const url = new URL(image.currentSrc || image.src, window.location.href);
        url.searchParams.set('_image_retry', Date.now().toString());
        image.src = url.toString();
      } catch (error) {
        console.warn('Image retry failed:', error);
      }
    },
    clearZeroAmount(event) {
      if (Number(this.money) === 0) {
        this.money = '';
        this.$nextTick(() => {
          if (event && event.target) event.target.value = '';
        });
      }
    },
    restoreZeroAmount() {
      if (this.money === '' || this.money === null || Number(this.money) < 0) {
        this.money = 0;
      }
    },
    getBetName(name) {
      const labels = { BESAR:this.$t('betOptions.rose')+' 🌹', KECIL:this.$t('betOptions.lily')+' ⚜️', GENAP:this.$t('betOptions.fireworks')+' 🎆', GANJIL:this.$t('betOptions.balloon')+' 🎈', '大':this.$t('betOptions.rose')+' 🌹', '小':this.$t('betOptions.lily')+' ⚜️', '双':this.$t('betOptions.fireworks')+' 🎆', '单':this.$t('betOptions.balloon')+' 🎈' };
      return labels[String(name || '').toUpperCase()] || labels[name] || name;
    },
    back() {
      return window.history.back();
    },
    
    getResultSum(opencode) {
      const values = Array.isArray(opencode) ? opencode : String(opencode || '').split(',');
      return values.slice(0, 3).reduce((total, value) => total + Number(value || 0), 0);
    },

    getSizeText(opencode) {
      const sum = this.getResultSum(opencode);
      return sum >= 11 && sum <= 18 ? this.$t('betOptions.rose') + ' 🌹' : this.$t('betOptions.lily') + ' ⚜️';
    },
    
    getDoubleText(opencode) {
      const sum = this.getResultSum(opencode);
      return sum % 2 === 0 ? this.$t('betOptions.fireworks') + ' 🎆' : this.$t('betOptions.balloon') + ' 🎈';
    },
    
    toggleHistory() {
      this.active = !this.active;
      if (this.active) {
        this.$nextTick(() => {
          if (this.$refs.historyTable) {
            this.$refs.historyTable.scrollTop = 0;
          }
        });
      }
    },
    
    updateGameInfo(key, id) {
      const gameInfo = this.game_type_list.find(game => game.key === key && game.id === id);
      if (gameInfo) {
        this.showtitle = gameInfo.name;
        this.showimage = gameInfo.ico || gameInfo.logo_pic;
      }
    },
    
    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'});
        return;
      }
      
      if (this.$route.name === 'Lottery') {
        this.updateGameInfo(key, id);
        this.$router.replace({path: '/Lottery', query: {key: key, id: id}});
        // 延迟加载，避免竞态条件
        setTimeout(() => {
          this.getLotteryInfo();
          this.getLotteryList();
        }, 300);
      } else {
        this.$router.push({path: '/Lottery', query: {key: key, id: id}});
      }
      this.showRight = false;
    },
    
    doSub() {
      if (this.submittingBet) return false;
      if (this.money === 0) {
        this.$toast(this.$t('game.plsmoney'));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t('game.plsnum'));
        return false;
      }
      if (this.userInfo.money - (this.money * this.formData.length) < 0) {
        this.$toast(this.$t('game.moneynote'));
        return false;
      }
      
      this.submittingBet = true;
      this.$http({
        method: 'post',
        data: {
          item: this.gameitem,
          money: this.money,
          lid: this.lottery.id,
          expect: this.lottery.next_expect
        },
        url: 'game_place_order'
      }).then(res => {
        this.submittingBet = false;
        if (res.code === 200) {
          this.$toast.success(this.$t('game.rewardSuccess'));
          this.allClear();
          this.getUserInfo();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      }).catch(() => {
        this.submittingBet = false;
      });
      return true;
    },
    
    allClear() {
      for (let i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]['type']] = false;
      }
      this.formData = [];
      this.money = 0;
      this.shopchoose = "Not selected";
      this.gameitem = "";
      this.shopping = false;
    },
    
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t('game.plsnum'));
        return false;
      }
      if (this.money === 0) {
        this.$toast(this.$t('game.plsmoney'));
        return false;
      }
      if (this.userInfo.money - (this.money * this.formData.length) < 0) {
        this.$toast(this.$t('game.moneynote'));
        return false;
      }
      
      this.showBetDetails = true;
    },

    confirmBet() {
      this.doSub();
    },
    
    clearChooes(type) {
      this.formData = this.formData.filter(item => item.type !== type);
      this.choose[type] = false;
      
      if (this.formData.length >= 1) {
        this.shopchoose = this.formData.map(item => this.$t("game." + item.name)).join(",");
        this.gameitem = this.formData.map(item => item.type).join(",");
      } else {
        this.shopchoose = "Not selected";
        this.gameitem = "";
        this.shopping = false;
      }
    },
    
    choosePlay(type, name) {
      if (this.choose[type]) {
        this.choose[type] = false;
        this.formData = this.formData.filter(item => item.type !== type);
      } else {
        this.formData.push({'name': name, 'type': type});
        this.choose[type] = true;
      }
      
      this.shopping = this.formData.length >= 1;
      if (this.formData.length >= 1) {
        this.shopchoose = this.formData.map(item => this.$t("game." + item.name)).join(",");
        this.gameitem = this.formData.map(item => item.type).join(",");
      } else {
        this.shopchoose = "Not selected";
        this.gameitem = "";
      }
    },
    
    check() {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'});
        return;
      }
      
      // 清除之前的定时器
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
      }
      
      // 使用防抖，避免频繁请求
      this.refreshTimer = setTimeout(() => {
        this.getLotteryInfo();
      }, 1000);
    },
    
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t('common.refresh'));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    
    getUserInfo() {
      return new Promise((resolve) => {
        this.$http({
          method: 'get',
          url: 'user_info'
        }).then(res => {
          if (res.code === 200) {
            this.userInfo = res.data;
          } else if (res.code === 401) {
            this.$toast(res.msg);
          }
          resolve();
        }).catch(() => resolve());
      });
    },
    
    getLotteryPeilv() {
      // 添加请求锁和参数验证
      if (this.isLoadingPeilv) return;
      if (!this.$route.query.id) {
        console.warn('缺少游戏ID参数');
        return;
      }
      
      this.isLoadingPeilv = true;
      
      this.$http({
        method: 'get',
        data: {id: this.$route.query.id},
        url: 'lottery_get_peilv'
      }).then(res => {
        if (res.code === 200) {
          this.lottery_peilv_list = res.data;
          this.retryCount = 0; // 重置重试计数
          // 缓存成功的数据
          localStorage.setItem('cached_peilv_data', JSON.stringify(res.data));
        } else if (res.code === 401) {
          this.$toast(res.msg);
        } else if (res.code === 500) {
          console.error('服务器内部错误，使用缓存数据');
          this.useCachedPeilvData();
        }
      }).catch(error => {
        console.error('获取赔率失败:', error);
        if (this.retryCount < this.MAX_RETRY) {
          this.retryCount++;
          console.log(`第${this.retryCount}次重试获取赔率...`);
          setTimeout(() => this.getLotteryPeilv(), 1000 * this.retryCount);
        } else {
          this.useCachedPeilvData();
        }
      }).finally(() => {
        this.isLoadingPeilv = false;
      });
    },
    
    // 添加缓存降级方案
    useCachedPeilvData() {
      const cached = localStorage.getItem('cached_peilv_data');
      if (cached) {
        this.lottery_peilv_list = JSON.parse(cached);
        this.$toast(this.$t('common.usingCachedData'));
      }
    },
    
    getGameItem() {
      return new Promise((resolve) => {
        this.$http({
          method: 'get',
          url: 'lottery_hot'
        }).then(res => {
          this.game_type_list = res.data;
          if (this.$route.query.key && this.$route.query.id) {
            this.updateGameInfo(this.$route.query.key, this.$route.query.id);
          }
          resolve();
        }).catch(() => resolve());
      });
    },
    
    getLotteryList() {
      // 添加请求锁，防止重复请求
      if (this.isLoadingLotteryList) return;
      if (!this.$route.query.key) {
        console.warn('缺少游戏key参数');
        return;
      }
      
      this.isLoadingLotteryList = true;
      
      this.$http({
        method: 'get',
        data: {key: this.$route.query.key},
        url: 'lottery_get_one_list'
      }).then(res => {
        if (res.code === 200) {
          this.lottery_list = res.data;
          // 移除这里的 getLotteryPeilv() 调用，避免重复
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      }).finally(() => {
        this.isLoadingLotteryList = false;
      });
    },
    
    getLotteryInfo() {
      if (!this.$route.query.key) {
        console.warn('缺少游戏key参数');
        return;
      }
      
      this.$http({
        method: 'get',
        data: {key: this.$route.query.key},
        url: 'lottery_get_info'
      }).then(res => {
        if (res.code === 200) {
          if (parseFloat(this.userInfo.money) < parseFloat(res.data.condition)) {
            this.$toast(this.$t('game.lxgly'));
            this.$router.push({path: '/Home'});
            return false;
          }
          this.lottery = res.data;
          this.showimage = res.data.ico;
          this.showtitle = res.data.name;
          this.time = res.data.second * 1000;

          if (this.time / 1000 === 59) {
            this.$toast(this.$t('game.kjcc') + this.lottery.now_expect);
          }
          
          this.sum = parseInt(res.data.opencode[0]) + parseInt(res.data.opencode[1]) + parseInt(res.data.opencode[2]);
          
          this.size = this.getSizeText(res.data.opencode);
          this.double = this.getDoubleText(res.data.opencode);
          
          // 成功获取信息后，再获取赔率数据
          if (!this.isLoadingPeilv) {
            this.getLotteryPeilv();
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    
    // 添加清理资源的方法
    cleanupResources() {
      this.isPageActive = false;
      // 清理所有定时器和请求
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = null;
      }
    }
  },
  
  // 页面生命周期优化
  activated() {
    this.isPageActive = true;
    // 延迟加载，避免与其他页面冲突
    setTimeout(() => {
      this.getLotteryInfo();
      this.getLotteryList();
    }, 500);
  },
  
  deactivated() {
    this.cleanupResources();
  },
  
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'});
    } else {
      // 顺序加载，避免并发请求冲突
      this.getUserInfo().then(() => {
        this.getGameItem().then(() => {
          // 延迟执行，确保参数正确
          setTimeout(() => {
            this.getLotteryInfo();
            this.getLotteryList();
          }, 300);
        });
      });
    }
  },
  
  destroyed() {
    this.cleanupResources();
    clearInterval(time);
  }
};
</script>

<style lang='less' scoped>
/* 样式保持不变，与之前相同 */
.lottery {
    width: 100%;
    min-height: 100vh;
    background: linear-gradient(135deg, #8e44ad 0%,#3498db 100%);
    position: relative;
    font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

/* 导航栏样式 */
.van-nav-bar {
    background: linear-gradient(135deg, #3498db, #8e44ad) !important;
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.2);
}

.van-nav-bar__title {
    color: #fff;
    font-weight: 600;
    font-size: 1.1rem;
}

.van-nav-bar .van-icon {
    color: #fff;
}

/* 顶部信息区域 */
.top {
    padding: 1.2rem 1rem;
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(15px);
    margin: 0.8rem;
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.game-info {
    display: flex;
    align-items: center;
    margin-bottom: 1.2rem;
}

.ico {
    width: 4rem;
    height: 4rem;
    border-radius: 16px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.1);
    padding: 0.4rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.ico img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
}

.info-text {
    flex: 1;
    margin-left: 1.2rem;
}

.info-text h1 {
    font-size: 1.4rem;
    color: #fff;
    font-weight: 700;
    margin-bottom: 0.4rem;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.countdown {
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    color: #4fc3f7;
}

.countdown-label {
    margin-right: 0.5rem;
}

/* 倒计时时间数字样式 */
.countdown .van-count-down {
    font-size: 1.3rem;
    color: #ffd54f;
    font-weight: bold;
    margin-left: 0.3rem;
    text-shadow: 0 0 10px rgba(255, 213, 79, 0.5);
}

/* 当前结果区域 */
.number {
    display: flex;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 16px;
    padding: 1.2rem;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    align-items: center;
}

.current-result {
    flex: 1;
    display: flex;
    align-items: center;
}

.current-result .ball p {
    font-size: 0.95rem;
    color: #333;
    font-weight: 600;
    line-height: 1.4;
}

.result-display {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
}

.res {
    display: flex;
    gap: 0.6rem;
}

.result-item {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.9rem;
    font-weight: 700;
    color: #fff;
    background: linear-gradient(135deg, #8e44ad, #3498db);
    box-shadow: 0 4px 10px rgba(142, 68, 173, 0.4);
    position: relative;
    overflow: hidden;
}

.result-item::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(rgba(255,255,255,0.1), rgba(255,255,255,0));
    transform: rotate(45deg);
}

/* 投注区域 */
.lottery-content {
    flex: 1;
    padding: 0.8rem;
}

.betting-area {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 20px;
    margin: 0.5rem;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    overflow: hidden;
}

.betting-options {
    max-height: 50vh;
    overflow-y: auto;
    padding: 0.5rem;
}

.options-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    padding: 0.5rem;
}

.option-item {
    background: #fff;
    border: 2px solid #e8e8e8;
    border-radius: 16px;
    padding: 1.4rem 0.8rem;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    position: relative;
    overflow: hidden;
}

.option-item::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #8e44ad, #3498db);
    transform: scaleX(0);
    transition: transform 0.3s ease;
}

.option-item:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.option-item.active {
    background: linear-gradient(135deg, #8e44ad, #3498db);
    border-color: #8e44ad;
    color: #fff;
    box-shadow: 0 8px 20px rgba(142, 68, 173, 0.4);
}

.option-item.active::before {
    transform: scaleX(1);
}

.option-item p {
    font-size: 1.05rem;
    font-weight: 600;
    margin-bottom: 0.4rem;
    color: inherit;
    position: relative;
    z-index: 1;
}

.odds {
    font-size: 0.85rem;
    opacity: 0.9;
    position: relative;
    z-index: 1;
}

/* 投注面板 */
.betting-panel {
  position: fixed;
  bottom: 4.5rem;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 24px 24px 0 0;
  box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  padding: 1.2rem;
}

.panel-content {
  padding: 0;
}

.amount-and-total {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 1rem;
}

.amount-input {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  background: #f8f9fa;
  padding: 0.8rem 1rem;
  border-radius: 12px;
  flex: 1;
  min-height: 60px; /* 添加最小高度 */
}

.amount-input p {
  font-size: 0.95rem;
  color: #333;
  font-weight: 500;
  white-space: nowrap;
  margin: 0;
}

.amount-input input {
  border: 2px solid #e8e8e8;
  border-radius: 10px;
  padding: 0.7rem 0.8rem;
  font-size: 0.95rem;
  text-align: center;
  width: 6rem;
  background: #fff;
  font-weight: 600;
  transition: all 0.3s ease;
}

.amount-input input:focus {
  border-color: #8e44ad;
  outline: none;
  box-shadow: 0 0 0 3px rgba(142, 68, 173, 0.2);
}

.total-info {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  padding: 0.8rem 1rem;
  border-radius: 12px;
  text-align: center;
  border: 1px solid #e8e8e8;
  flex: 1;
  min-height: 60px; /* 添加最小高度 */
    display: flex;
    align-items: center;
    justify-content: center;
}

.total-info p {
  font-size: 0.9rem;
  color: #333;
  font-weight: 500;
  margin: 0;
  line-height: 1.4;
}

.highlight {
  color: #8e44ad;
  font-weight: 700;
  margin: 0 0.2rem;
}

/* 底部操作栏 */
.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.2rem 1.5rem;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
    z-index: 1001;
    border-radius: 24px 24px 0 0;
}

.balance-info p {
    font-size: 0.95rem;
    color: #666;
}

.balance {
    color: #8e44ad;
    font-weight: 700;
    margin-left: 0.3rem;
    font-size: 1.1rem;
}

.confirm-btn {
    background: linear-gradient(135deg, #8e44ad, #3498db);
    color: #fff;
    border: none;
    border-radius: 30px;
    padding: 1rem 2.2rem;
    font-size: 1.05rem;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 6px 20px rgba(142, 68, 173, 0.4);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.confirm-btn::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(rgba(255,255,255,0.1), rgba(255,255,255,0));
    transform: rotate(45deg);
    transition: all 0.5s ease;
}

.confirm-btn:active {
    transform: scale(0.96);
    box-shadow: 0 4px 15px rgba(142, 68, 173, 0.5);
}

/* 历史记录 */
.history {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 2000;
    display: flex;
    align-items: flex-end;
    animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

.history-content {
    background: #fff;
    border-radius: 24px 24px 0 0;
    width: 100%;
    height: 80vh;
    max-height: 80vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    animation: slideUp 0.3s ease;
}

@keyframes slideUp {
    from { transform: translateY(100%); }
    to { transform: translateY(0); }
}

.history-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 1.5rem;
    border-bottom: 1px solid #f0f0f0;
    background: #f8f9fa;
}

.history-header h3 {
    font-size: 1.2rem;
    color: #333;
    font-weight: 700;
    margin: 0;
}

.close-icon {
    font-size: 1.4rem;
    color: #666;
    cursor: pointer;
    padding: 0.4rem;
    border-radius: 50%;
    transition: all 0.3s ease;
}

.close-icon:active {
    background: #e8e8e8;
}

.history-body {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 0 1.2rem 1.2rem;
    background: #070a0e;
}

.history-table {
    flex: 1;
    width: 100%;
    min-height: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-y;
    background: #070a0e;
}

.history-columns,
.history-record {
    display: grid;
    grid-template-columns: 44% 56%;
}

.history-columns {
    flex: 0 0 auto;
    width: 100%;
    z-index: 3;
    background: #070a0e;
    border-bottom: 1px solid rgba(218,180,105,.22);
}

.history-columns p {
    margin: 0;
    padding: .8rem;
    text-align: center;
}

.history-record {
    min-height: 6.1rem;
    border-bottom: 1px solid rgba(218,180,105,.18);
}

.history-expect,
.history-record .mak {
    display: flex;
    align-items: center;
    justify-content: center;
}

.history-expect {
    color: #d8cbb7;
    border-right: 1px solid rgba(218,180,105,.22);
    background: rgba(216,177,99,.055);
}

.history-record .mak {
    flex-direction: column;
}

.history-table ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

.history-body .left,
.history-body .right {
    flex: 1;
    padding: 1.2rem;
    overflow-y: auto;
}

.history-body .left {
    background: #f8f9fa;
    border-right: 1px solid #e8e8e8;
}

.history-body p {
    font-size: 0.95rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 1rem;
    position: sticky;
    top: 0;
    background: inherit;
    padding: 0.5rem 0;
}

.history-body ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.history-body li {
    padding: 1rem 0;
    border-bottom: 1px solid #f0f0f0;
    text-align: center;
    font-size: 0.9rem;
    color: #666;
    transition: background 0.2s ease;
}

.history-body li:active {
    background: #f0f0f0;
}

/* CSS骰子样式 - 替换图片 */
.idem1, .idem2, .idem3, .idem4, .idem5, .idem6 {
    width: 2.4rem;
    height: 2.4rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 0.3rem;
    border-radius: 12px;
    font-weight: 800;
    color: white;
    font-size: 1.3rem;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
    position: relative;
    overflow: hidden;
}

.idem1::after, .idem2::after, .idem3::after, .idem4::after, .idem5::after, .idem6::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(rgba(255,255,255,0.2), rgba(255,255,255,0));
    transform: rotate(45deg);
}

/* 不同点数的颜色变化 */
.idem1 { background: linear-gradient(145deg, #ff6b6b, #ff4757); }
.idem2 { background: linear-gradient(145deg, #ff9ff3, #f368e0); }
.idem3 { background: linear-gradient(145deg, #54a0ff, #2e86de); }
.idem4 { background: linear-gradient(145deg, #1dd1a1, #10ac84); }
.idem5 { background: linear-gradient(145deg, #feca57, #ff9ff3); }
.idem6 { background: linear-gradient(145deg, #5f27cd, #341f97); }

/* 游戏切换弹窗 */
.game-switch-popup {
    padding: 1.5rem;
    background: #f8f9fa;
    height: 100%;
    overflow-y: auto;
}

.game-item {
    background: #fff;
    border-radius: 16px;
    padding: 1.4rem;
    margin-bottom: 1rem;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid transparent;
}

.game-item:active {
    background: #f0f0f0;
    transform: scale(0.98);
}

.game-item p {
    font-size: 1.05rem;
    font-weight: 600;
    color: #333;
    margin: 0;
}

/* 动画效果 */
.down {
  transition: all 0.3s ease;
}

.up{
  transform: rotate(180deg);
  transition: all 0.3s ease;
}

.van-icon {
  font-size: 1.3rem;
}

/* 滚动条样式 */
.betting-options::-webkit-scrollbar {
    width: 6px;
}

.betting-options::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.betting-options::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #8e44ad, #3498db);
    border-radius: 3px;
}

.betting-options::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #7d3c98, #2980b9);
}

/* 响应式调整 */
@media (max-width: 375px) {
    .options-grid {
        grid-template-columns: 1fr;
        gap: 0.8rem;
    }
    
    .result-item {
        width: 2.2rem;
        height: 2.2rem;
        font-size: 0.8rem;
    }
    
    .footer {
        padding: 1rem 1.2rem;
    }
    
    .confirm-btn {
        padding: 0.9rem 1.8rem;
        font-size: 1rem;
    }
    
    /* 小屏幕骰子调整 */
    .idem1, .idem2, .idem3, .idem4, .idem5, .idem6 {
        width: 2rem;
        height: 2rem;
        font-size: 1.1rem;
        margin: 0 0.2rem;
    }
    
    .top {
        margin: 0.5rem;
        padding: 1rem 0.8rem;
    }
    
    .game-info {
        margin-bottom: 1rem;
    }
    
    .ico {
        width: 3.5rem;
        height: 3.5rem;
    }
    
    .info-text h1 {
        font-size: 1.2rem;
    }
}

/* 独立玩法页：黑金轻奢主题 */
.lottery { color:#f3eadb; background:linear-gradient(rgba(3,5,8,.83),rgba(3,5,8,.97)),url('../../assets/img/luxury-dating-bg-v2.png') center top/cover fixed no-repeat !important; }
.lottery .van-nav-bar { height:4rem !important; line-height:4rem; border-bottom:1px solid rgba(218,180,105,.42); background:rgba(4,6,9,.97) !important; box-shadow:0 .55rem 1.5rem rgba(0,0,0,.38); }
.lottery .van-nav-bar__title,.lottery .van-nav-bar .van-icon,.lottery .van-nav-bar__right span { color:#efd18a !important; font-weight:700; }
.top { margin:.8rem; padding:1rem; border:1px solid rgba(218,180,105,.38); border-radius:1.25rem; background:radial-gradient(circle at 90% 5%,rgba(226,187,105,.13),transparent 35%),linear-gradient(145deg,rgba(17,19,23,.97),rgba(6,8,12,.98)); box-shadow:0 1rem 2.4rem rgba(0,0,0,.42); }
.qs { background:transparent !important; }.ico { border:1px solid #d9b66e; border-radius:.8rem; overflow:hidden; box-shadow:0 0 0 .25rem rgba(218,180,105,.08); }
.info-text h1 { color:#efd18a !important; font-size:1.25rem !important; }.countdown,.countdown-label,.van-count-down { color:#d9cbb5 !important; font-size:.94rem !important; }.van-count-down { color:#f0cf82 !important; font-weight:750; }
.number { padding:.9rem; border:1px solid rgba(218,180,105,.25); border-radius:1rem; background:rgba(3,5,8,.68) !important; }.current-result .ball p { color:#e8ddcb !important; font-size:.9rem !important; }
.result-item,.idem1,.idem2,.idem3,.idem4,.idem5,.idem6 { color:#171006 !important; border:1px solid rgba(250,223,162,.65) !important; background:linear-gradient(135deg,#a97732,#e7c87c) !important; box-shadow:0 .45rem 1.1rem rgba(185,130,48,.25) !important; text-shadow:none !important; }
.result-display>.van-icon { color:#d7b56d !important; }
/* 主玩法页开奖结果与弹窗保持一致：和值圆形，结果名称上下宽标签 */
.result-display .res {
  display:grid;
  grid-template-columns:2.6rem minmax(6.8rem,1fr);
  grid-template-rows:repeat(2,1.9rem);
  align-items:center;
  gap:.35rem .55rem;
  min-width:10rem;
}
.result-display .result-item.sum {
  grid-column:1;
  grid-row:1 / 3;
  width:2.6rem;
  height:2.6rem;
  border-radius:50%;
  font-size:.88rem;
}
.result-display .result-item.size,
.result-display .result-item.double {
  grid-column:2;
  width:100%;
  min-width:6.8rem;
  height:1.9rem;
  padding:0 .65rem;
  box-sizing:border-box;
  border-radius:.65rem;
  font-size:.8rem;
  line-height:1;
  white-space:nowrap;
}
.result-display .result-item.size { grid-row:1; }
.result-display .result-item.double { grid-row:2; }
.result-display .result-item::after { pointer-events:none; }
.lottery-content { margin:.8rem; padding:1rem; min-height:11rem; border:1px solid rgba(218,180,105,.32); border-radius:1.2rem; background:linear-gradient(145deg,rgba(14,17,22,.96),rgba(5,8,12,.98)) !important; box-shadow:0 1rem 2.2rem rgba(0,0,0,.38); }
.betting-area,.betting-options { background:transparent !important; }.options-grid { gap:.75rem; }
.option-item { min-height:5.5rem; color:#e4c37d; border:1px solid rgba(218,180,105,.38) !important; border-radius:1rem; background:rgba(12,14,18,.94) !important; box-shadow:inset 0 1px 0 rgba(255,255,255,.035),0 .5rem 1.2rem rgba(0,0,0,.24) !important; }
.option-item::before { display:none; }.option-item p { color:#e7c77f !important; font-size:1rem !important; }.option-item .odds { color:#a99d8b !important; font-size:.82rem; }
.option-item.active { border-color:#edcf87 !important; background:linear-gradient(110deg,#9f6d2d,#e5c47b) !important; }.option-item.active p,.option-item.active .odds { color:#171006 !important; }
.footer { border-top:1px solid rgba(218,180,105,.38) !important; background:rgba(5,7,10,.96) !important; box-shadow:0 -1rem 2.5rem rgba(0,0,0,.4); backdrop-filter:blur(14px); }
.balance-info p { color:#cdbfa9 !important; font-size:.9rem !important; }.balance-info .balance { color:#edcf87 !important; font-size:1rem; }
.confirm-btn { color:#171006 !important; font-size:1rem !important; font-weight:750; border:1px solid rgba(247,220,160,.68) !important; border-radius:1rem !important; background:linear-gradient(110deg,#a97732,#e7c87c,#bb853c) !important; box-shadow:0 .7rem 1.6rem rgba(185,130,48,.3) !important; }
.history-content,.game-switch-popup { color:#f3eadb; border-color:rgba(218,180,105,.4); background:#090c11 !important; }.history-header,.game-item { color:#efd18a; border-color:rgba(218,180,105,.28); background:rgba(216,177,99,.07) !important; }.game-item p { color:#e6c57e !important; }
.history-header h3 { color:#efd18a !important; }
.close-icon { color:#b9ad99 !important; }
.close-icon:active { color:#efd18a !important; background:rgba(218,180,105,.12) !important; }
.history-body { background:#070a0e !important; }
.history-body .left {
  border-right:1px solid rgba(218,180,105,.28) !important;
  background:linear-gradient(180deg,rgba(25,20,12,.92),rgba(8,11,15,.98)) !important;
}
.history-body .right { background:#070a0e !important; }
.history-body p {
  color:#e7c77f !important;
  background:rgba(10,12,16,.96) !important;
}
.history-body .left li {
  color:#d8cbb7 !important;
  border-bottom:1px solid rgba(218,180,105,.17) !important;
  background:rgba(216,177,99,.025);
}
.history-body .left li:nth-child(odd) { background:rgba(216,177,99,.055); }
.history-body .left li:active {
  color:#171006 !important;
  background:linear-gradient(110deg,#a97732,#e7c87c) !important;
}
.history-table { background:#070a0e !important; }
.history-columns { background:#070a0e !important; }
.history-columns p { color:#e7c77f !important; background:rgba(10,12,16,.98) !important; }
.history-record { padding:0 !important; color:#d8cbb7 !important; }
.history-record:active { background:rgba(218,180,105,.08) !important; }
.betting-panel {
  border:1px solid rgba(218,180,105,.42);
  border-bottom:0;
  background:linear-gradient(145deg,rgba(13,16,21,.98),rgba(5,7,10,.99)) !important;
  box-shadow:0 -1rem 2.5rem rgba(0,0,0,.55),inset 0 1px 0 rgba(255,255,255,.035) !important;
}
.amount-input,
.total-info {
  color:#e7dcc8 !important;
  border:1px solid rgba(218,180,105,.32) !important;
  background:rgba(16,19,24,.96) !important;
}
.amount-input p,
.total-info p { color:#e7dcc8 !important; }
.amount-input input {
  color:#edcf87 !important;
  border:1px solid rgba(218,180,105,.42) !important;
  background:#080b0f !important;
  box-shadow:inset 0 2px 8px rgba(0,0,0,.38);
}
.amount-input input:focus {
  border-color:#edcf87 !important;
  box-shadow:0 0 0 3px rgba(218,180,105,.14) !important;
}
.highlight { color:#edcf87 !important; }
.bet-detail-dialog { padding:.8rem 1.1rem 1.2rem; color:#e8dcc8; background:#090c11; }
.bet-detail-row,.bet-detail-item { min-height:2.8rem; display:flex; align-items:center; gap:.6rem; border-bottom:1px solid rgba(218,180,105,.18); }
.bet-detail-row span,.bet-detail-item span { flex:1; color:#bfb3a1; }
.bet-detail-row strong,.bet-detail-item strong { color:#edcf87; }
.bet-detail-item em { color:#a99d8b; font-style:normal; }
.bet-detail-list { margin:.35rem 0; padding:.2rem .75rem; border:1px solid rgba(218,180,105,.28); border-radius:.8rem; background:rgba(216,177,99,.05); }
::v-deep .van-dialog { overflow:hidden; border:1px solid rgba(218,180,105,.42); background:#090c11; }
::v-deep .van-dialog__header {
  padding:1.35rem 1rem 1.1rem !important;
  color:#efd18a;
  background:#090c11;
  font-size:1.3rem !important;
  line-height:1.45 !important;
  font-weight:700 !important;
}
::v-deep .van-dialog__footer { border-top:1px solid rgba(218,180,105,.25); background:#090c11; }
::v-deep .van-dialog__cancel { color:#c7b99f; background:#101319; }
::v-deep .van-dialog__confirm { color:#171006; background:linear-gradient(110deg,#a97732,#e7c87c); }
::v-deep .van-dialog__cancel,
::v-deep .van-dialog__confirm {
  height:4rem !important;
  font-size:1.15rem !important;
  font-weight:700 !important;
  line-height:1.4 !important;
}
::v-deep .van-dialog__cancel .van-button__text,
::v-deep .van-dialog__confirm .van-button__text {
  font-size:1.15rem !important;
}

/* Low-resolution phones: let content reflow instead of forcing desktop-sized
   halves into the same row. Keep this block last so it wins over legacy rules. */
.lottery {
  min-width: 0;
  min-height: 100dvh;
  padding-bottom: calc(6.6rem + env(safe-area-inset-bottom));
  overflow-x: hidden;
}

.game-info,
.info-text,
.number,
.current-result,
.result-display,
.result-display .res,
.balance-info {
  min-width: 0;
}

.info-text h1,
.current-result .ball p {
  overflow-wrap: anywhere;
}

.footer {
  width: 100%;
  max-width: 26.875rem;
  margin-inline: auto;
  padding-bottom: calc(1.2rem + env(safe-area-inset-bottom));
}

@media (max-width: 430px) {
  .top,
  .lottery-content {
    margin: .55rem;
  }

  .top {
    padding: .75rem;
  }

  .game-info {
    align-items: flex-start;
    gap: .75rem;
    margin-bottom: .8rem;
  }

  .ico {
    flex: 0 0 3.4rem;
    width: 3.4rem;
    height: 3.4rem;
    padding: .25rem;
  }

  .info-text {
    margin-left: 0;
  }

  .info-text h1 {
    margin: 0 0 .35rem;
    font-size: clamp(1rem, 5.2vw, 1.25rem) !important;
    line-height: 1.25;
  }

  .countdown {
    flex-wrap: wrap;
    gap: .15rem .35rem;
    line-height: 1.35;
  }

  .countdown-label,
  .countdown .van-count-down {
    margin: 0;
    font-size: clamp(.78rem, 3.8vw, .94rem) !important;
  }

  .number {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: .65rem;
    padding: .75rem;
  }

  .current-result {
    width: auto;
  }

  .current-result .ball p {
    margin: 0;
    font-size: clamp(.72rem, 3.6vw, .9rem) !important;
    line-height: 1.35;
  }

  .result-display {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 1.15rem;
    gap: .35rem;
  }

  .result-display .res {
    grid-template-columns: 2.35rem minmax(4.7rem, 1fr);
    grid-template-rows: repeat(2, 1.75rem);
    gap: .3rem .4rem;
    min-width: 0;
  }

  .result-display .result-item.sum {
    width: 2.35rem;
    height: 2.35rem;
    font-size: .8rem;
  }

  .result-display .result-item.size,
  .result-display .result-item.double {
    min-width: 0;
    height: 1.75rem;
    padding: 0 .4rem;
    font-size: .72rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .lottery-content {
    padding: .65rem;
  }

  .betting-options,
  .options-grid {
    padding: .35rem;
  }

  .options-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: .55rem;
  }

  .option-item {
    min-width: 0;
    min-height: 4.8rem;
    padding: .9rem .4rem;
  }

  .option-item p {
    margin: 0;
    overflow-wrap: anywhere;
  }

  .footer {
    gap: .7rem;
    padding: .85rem max(.8rem, env(safe-area-inset-left))
      calc(.85rem + env(safe-area-inset-bottom))
      max(.8rem, env(safe-area-inset-right));
    border-radius: 1.15rem 1.15rem 0 0;
  }

  .balance-info {
    flex: 1 1 auto;
  }

  .balance-info p {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: .2rem .45rem;
    margin: 0;
    line-height: 1.25;
  }

  .balance-info .balance {
    margin-left: 0;
    overflow-wrap: anywhere;
  }

  .confirm-btn {
    flex: 0 0 auto;
    min-width: 6.4rem;
    padding: .85rem 1.15rem;
  }
}

@media (max-width: 340px) {
  .number {
    grid-template-columns: 1fr;
  }

  .result-display .res {
    grid-template-columns: 2.2rem minmax(0, 1fr);
  }

  .options-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: .45rem;
  }

  .option-item {
    min-height: 4.5rem;
    padding-inline: .25rem;
  }

  .option-item p {
    font-size: .86rem !important;
  }

  .footer {
    align-items: stretch;
  }

  .confirm-btn {
    min-width: 5.5rem;
    padding-inline: .8rem;
  }
}
</style>
